// extracted by mini-css-extract-plugin
export default {"resources":"ParentAccordion_resources__T29EZ","resources_wrapper":"ParentAccordion_resources_wrapper__Yfoz2"};